
var scroller = document.querySelector('.scroller');
scroller.onscroll = function (event) {
  handleScroll(event.srcElement);
};

handleScroll(scroller);

document.querySelector('.filter-head').onclick = function () {
  var scroller = document.querySelector('.scroller');
  if (scroller.scrollTop === 0) {
    scroller.classList.toggle('scrolled-out');
    scroller.scrollTop = 2;
    return;
  }
   document.querySelector('.filter').classList.toggle('show');
};

function handleScroll (div) {
  var top = div.scrollTop;
  var left = div.scrollLeft;
  var right = div.scrollWidth - div.offsetWidth - left;
  if (top < 1) {
    div.classList.remove('scrolled-out');
  } else {
    div.classList.add('scrolled-out');
  }
  if (left < 1) {
    div.classList.remove('scrolled-left-out');
  } else {
    div.classList.add('scrolled-left-out');
  }
  
  if (right < 1) {
    div.classList.remove('scrolled-right-out');
  } else {
    div.classList.add('scrolled-right-out');
  }
}

function onPush (el, action, delay) {
  var interval;
  el.addEventListener('mousedown', function (event) {
    interval = setInterval(function () {
      action(event)
    }, delay);
  });
  window.addEventListener('mouseup', function () {
    clearInterval(interval);
  });
}




onPush(
  document.querySelector('.arrow-left'),
  function (event) {
    scroller.scrollLeft = scroller.scrollLeft - 20;
  },
  20
)

onPush(
  document.querySelector('.arrow-right'),
  function (event) {
    scroller.scrollLeft = scroller.scrollLeft + 20;
  },
  20
)



// function offsetToParent (el, parent, offset) {
  
//   if (!offset) { offset = {top: 0, left: 0}; }
//   if (el === parent || !el) { return offset; }
  
//   offset.top += el.offsetTop;
//   offset.left += el.offsetLeft;
//   return offsetToParent(el.parentNode, parent, offset);
  
// }


// document.querySelector('.scroller').onscroll = function (event) {
//    var left = event.target.scrollLeft;
//    var top = event.target.scrollTop;
//    var toFix = document.querySelectorAll('.sticky, th');
//    for (var i = 0; i < toFix.length; i++) {
     
      
//      var el = toFix[i];
//      if (window.getComputedStyle(el).position !== 'sticky') { 
//       // el.style.transform = 'translateX(' + left + 'px)';
       
//        const offset = offsetToParent(el, event.target);
       
//        if (window.getComputedStyle(el).top !== 'auto') {
//            var elTop = parseInt(window.getComputedStyle(el).top);
//            var moveBy = top - offset.top + elTop;
//            if (moveBy < 0) { moveBy = 0; }
//            el.style.transform = 'translateY(' + moveBy + 'px)';
//        }
       
//      }
//    }

// };